import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  createdLandmarkData: object;
  settingMasterData: object;
  landmarkData: any;
  landmarkTotalData: any;
  LandmarkMasterEditData: object;
  error: string;
}

const initialArgs: Master = {
  createdLandmarkData: {},
  settingMasterData: {},
  landmarkData: [],
  LandmarkMasterEditData: {},
  error: "",
  landmarkTotalData: [],
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useLandmarkMaster = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getLandmarkMasterOption = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/landmark?page=${page ? page : ""}&pageSize=${pageSize ? pageSize : ""}&searchValue=${searchText ? searchText : ""}&sort=${sort ? sort : ""}&order=${order ? order : ""}`,
      );

      if (result.data.status) {
        const totalData = result.data.data[0].metadata.count;
        const filteredLandmarkData = result.data.data[0].rows.map(
          (item: any) => {
            return { ...item, id: item._id };
          },
        );
        setState({
          ...state,
          landmarkData: filteredLandmarkData,
          landmarkTotalData: totalData,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateLandmarkMaster = async (landmarkId: any, param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.put(
        `/api/landmark/${landmarkId}`,
        paramObj,
      );

      if (result.data.status) {
        // setState({ ...state, documentMasterEditData: result.data.data });
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const editLandmarkMaster = async (landmarkMasterId: string) => {
    try {
      const result: any = await api.get(`/api/landmark/${landmarkMasterId}`);

      if (result.data.status) {
        setState({ ...state, LandmarkMasterEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createLandmarkMaster = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/landmark", paramObj);

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, createdLandmarkData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  return {
    getLandmarkMasterOption,
    updateLandmarkMaster,
    editLandmarkMaster,
    createLandmarkMaster,
    ...state,
  };
};

export default useLandmarkMaster;
